/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { OrderLike } from '@/lib/order-management/types';

/**
 * Ownership guard: true only when a concrete shopper `customerId` matches the
 * order's `customerInfo.customerId`. Both sides must be concrete — the explicit
 * `!!customerId` check prevents an `undefined === undefined` false positive that
 * would treat a guest/unowned order as owned.
 */
export function isOrderOwnedBy(order: OrderLike, customerId: string | undefined | null): boolean {
    return !!customerId && customerId === order?.customerInfo?.customerId;
}
